module.exports = __webpack_public_path__ + "img/knowledge-base-bg-dark.3c12b193.png";